export default __webpack_public_path__ + "static/media/musclecare.6f0594fd.jpg";